import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicLinkService";
const store = {};
const mutations = {
    SET_CLUSTER_LIST(state, posts) {
        state.clusterList = posts;
        state.clusterListIsLoading = false;
    },
    SET_MFG_LIST(state, posts) {
        state.mfgList = posts;
        state.mfgListIsLoading = false;
    },
    SET_MENTOR_LIST(state, posts) {
        state.mentorList = posts;
        state.mentorListIsLoading = false;
    },
    SET_EVENT_LIST(state, posts) {
        state.eventList = posts;
        state.eventListIsLoading = false;
    },
    SET_NEWS_LIST(state, posts) {
        state.newsList = posts;
        state.newsListIsLoading = false;
    },
    ADD_TOPIC_LINK() { },
    ADD_TO_CLUSTER(state, posts) {
        if (posts.isNew && posts.topic) {
            const curTopic = state.clusterList.find(m => m.Title == posts.topic.Title && m.TopicId == 0);
            if (curTopic != null) {
                curTopic.TopicId = posts.topic.TopicId;
                curTopic.SchaltzeitId = posts.topic.SchaltzeitId;
                curTopic.Title = posts.topic.Title;
            }
        }
    },
    ADD_TO_MFG(state, posts) {
        if (posts.isNew && posts.topic) {
            const curTopic = state.mfgList.find(m => m.Title == posts.topic.Title && m.TopicId == 0);
            if (curTopic != null) {
                curTopic.TopicId = posts.topic.TopicId;
                curTopic.SchaltzeitId = posts.topic.SchaltzeitId;
                curTopic.Title = posts.topic.Title;
            }
        }
    },
    ADD_MENTOR_TO_MFG(state, posts) {
        if (posts.isNew && posts.topic) {
            const curTopic = state.mfgList.find(m => m.Title == posts.topic.Title && m.TopicId == 0);
            if (curTopic != null) {
                curTopic.TopicId = posts.topic.TopicId;
                curTopic.SchaltzeitId = posts.topic.SchaltzeitId;
                curTopic.Title = posts.topic.Title;
            }
        }
    },
    ADD_MEMBER_TO_MENTOR(state, posts) {
        if (posts.isNew && posts.topic) {
            const curTopic = state.mentorList.find(m => m.Title == posts.topic.Title && m.TopicId == 0);
            if (curTopic != null) {
                curTopic.TopicId = posts.topic.TopicId;
                curTopic.SchaltzeitId = posts.topic.SchaltzeitId;
                curTopic.Title = posts.topic.Title;
            }
        }
    },
    ADD_MENTOR_TO_MEMBER(state, posts) {
        if (posts.isNew && posts.topic) {
            const curTopic = state.mentorList.find(m => m.Title == posts.topic.Title && m.TopicId == 0);
            if (curTopic != null) {
                curTopic.TopicId = posts.topic.TopicId;
                curTopic.SchaltzeitId = posts.topic.SchaltzeitId;
                curTopic.Title = posts.topic.Title;
            }
        }
    },
    REMOVE_FROM_CLUSTER() {
    },
    CHANGE_TOPICLINK_STATUS() {
    },
    REMOVE_FROM_TOPIC() {
    },
    REMOVE_FROM_MENTOR() {
    },
    GET_TOPIC_LINKLIST(state, data) {
        
        var topicLinks = data && data.TopicList1 ? (data.TopicList1 ? data.TopicList1.concat(data.TopicList2) : data.TopicList2) : [];
        state.topicLinkList = topicLinks;
    },

    GET_TOPICLINK_ACTION_BY_STATUS(state, data) {
        state.topicLinkActionList = data.data.list;
    },
    GET_LINKED_TOPICS_BY_LINKTYPE(state, data) {
        state.linkedTopicsByLinkTypeList = data.data.list;
    },
    GET_TOPICLIST_FOR_LINKING(state, data) {
        state.topicLinksForLinking = data.data.topics;
    },
    GET_MY_AIGRID_PROFILES(state, data) {
        state.myProfiles = data.profiles;
    },
    GET_AIGRID_COMMUNITY_PROFILES(state, data) {
        state.communityProfiles = data.profiles;
    },
    ADD_TOPIC_TO_MFG() {
    },
    ADD_TOPIC_TO_EVENT() {
    },
};
const state = {
    clusterListIsLoading: false,
    clusterList: [],
    communityProfiles: [],
    myProfiles: {},
    topicLinksForLinking: [],
    mfgListIsLoading: false,
    mfgList: [],
    mentorListIsLoading: false,
    mentorList: [],
    eventListIsLoading: false,
    newsListIsLoading: false,
    eventList: [],
    newsList: [],
    topicLinkList: [],
    topicLinkActionList: [],
    linkedTopicsByLinkTypeList: [],
};
const getters = {};
const actions = {
    getClusterList({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetClusterList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_CLUSTER_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getMyAiGridProfiles({ commit }, { ttyId }) {
        state.myCartsAndPublicListIsLoading = true;
        return axios
            .get(baseUri + '/GetMyAiGridProfiles', { params: { ttyId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_MY_AIGRID_PROFILES', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getAiGridCommunityProfiles({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        return axios
            .get(baseUri + '/GetAiGridCommunityProfiles')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_AIGRID_COMMUNITY_PROFILES', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getMfgList({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetMfgList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MFG_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getEventList({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetEventList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_EVENT_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getNewsList({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetNewsList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_NEWS_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getMentorList({ commit }) {
        state.myCartsAndPublicListIsLoading = true;
        axios
            .get(baseUri + '/GetMentorList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MENTOR_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    addToCluster({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/AddToCluster', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_TO_CLUSTER', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    addToTopic({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        return axios.post(baseUri + '/AddToTopic', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_TO_MFG', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    addTopicToMfg({ commit }, { args, topicId }) {
        var formData = new FormData();
        formData.append("args", args);
        formData.append("topicId", topicId);
        return axios.post(baseUri + '/AddTopicToMfg', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('ADD_TOPIC_TO_MFG', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    addTopicToEvent({ commit }, { args, topicId }) {
        var formData = new FormData();
        formData.append("args", args);
        formData.append("topicId", topicId);
        return axios.post(baseUri + '/AddTopicToEvent', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('ADD_TOPIC_TO_EVENT', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    addMentorToMfg({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/AddMentorToMfg', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_MENTOR_TO_MFG', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    addMemberToMentor({ commit }, { args, topicId, ttyId }) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", args);
        formData.append("topicId", topicId);
        formData.append("ttyId", ttyId);
        return axios.post(baseUri + '/AddMemberToMentor', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_MEMBER_TO_MENTOR', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    addMentorToMember({ commit }, { args, topicId, ttyId }) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", args);
        formData.append("topicId", topicId);
        formData.append("ttyId", ttyId);
        return axios.post(baseUri + '/AddMentorToMember', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_MENTOR_TO_MEMBER', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    removeFromCluster({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/RemoveFromCluster', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('REMOVE_FROM_CLUSTER', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    removeFromTopic({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/RemoveFromTopic', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('REMOVE_FROM_TOPIC', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    removeFromMentor({ commit }, args) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("args", JSON.stringify(args));
        axios.post(baseUri + '/RemoveFromMentor', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('REMOVE_FROM_MENTOR', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicLinkList({ commit }, topicId) {
        var formData = new FormData();
         
        formData.append("topicId", JSON.stringify(topicId));
        return axios.post(baseUri + '/GetTopicLinkList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPIC_LINKLIST', res.data.topicLinkList);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getTopicLinkListTopicIds({ commit }, topicIdList) {
        var formData = new FormData();
        formData.append("topicIdList", JSON.stringify(topicIdList));
        return axios.post(baseUri + '/GetTopicLinkList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPIC_LINKLIST', res.data.topicLinkList);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getTopicLinkListEx({ commit }, { topicId, withPhoto }) {
        var formData = new FormData(); 
        formData.append("topicId", topicId);
        formData.append("withPhoto", withPhoto);
        return axios.post(baseUri + '/GetEsaTopicLinkListEx', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPIC_LINKLIST', res.data.topicLinkList);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    changeTopicLinkStatus({ commit }, { topicId, statusId, tliId }) {
        var formData = new FormData();
        formData.append("topicId", topicId);
        formData.append("statusId", statusId);
        formData.append("tliId", tliId);
        return axios.post(baseUri + '/ChangeTopicLinkStatus', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('CHANGE_TOPICLINK_STATUS');
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },
    getTopicLinkActionByStatus({ commit }, { args, topicId }) {
        return axios.get(baseUri + '/GetTopicLinkActionByStatus', { params: { args, topicId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICLINK_ACTION_BY_STATUS', res);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getTopicListForLinking({ commit }, { tlsId }) {
        return axios.get(baseUri + '/GetTopicListForLinking', { params: { tlsId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICLIST_FOR_LINKING', res);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    addTopicLink({ commit }, { tlsId, topicId1, idList, categoryId }) { 
        var formData = new FormData();
        formData.append("tlsId", tlsId);
        formData.append("topicId1", topicId1);
        formData.append("idList", idList);
        formData.append("categoryId", categoryId);
        return axios.post(baseUri + '/AddTopicLink', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('ADD_TOPIC_LINK', res);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getLinkedTopicsByLinkType({ commit }, { tltId, topicId }) {
        return axios.get(baseUri + '/GetLinkedTopicsByLinkType', { params: { tltId, topicId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_LINKED_TOPICS_BY_LINKTYPE', res);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}